/** Доля элемента, видимая в окне и внутри прокручиваемых/обрезающих родителей. */
export function visibleRatio(element: HTMLElement): number {
  const box = element.getBoundingClientRect();
  if (!box.width || !box.height) return 0;
  let left = Math.max(0, box.left), top = Math.max(0, box.top);
  let right = Math.min(innerWidth, box.right), bottom = Math.min(innerHeight, box.bottom);
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    const style = getComputedStyle(parent), bounds = parent.getBoundingClientRect();
    if (/auto|scroll|hidden|clip/.test(style.overflowX)) { left = Math.max(left, bounds.left); right = Math.min(right, bounds.right); }
    if (/auto|scroll|hidden|clip/.test(style.overflowY)) { top = Math.max(top, bounds.top); bottom = Math.min(bottom, bounds.bottom); }
  }
  return Math.max(0, right - left) * Math.max(0, bottom - top) / (box.width * box.height);
}
